import { useQuery } from 'react-query';
import { landingPageDesignGroupsKeys } from './keys';
import { EXPRESS_API } from 'configs/api/expressApi';
import { ILandingPageDesignGroupWithLandingPages } from 'app/pages/admin/landing-pages-v2/types';
import { errorToast } from 'lib/components/toasts/error';

export interface IManageGroupsResponse {
  count: number;
  data: ILandingPageDesignGroupWithLandingPages[];
}

export type ManageGroupsParams = {
  start?: number;
  limit?: number;
  search?: string;
  groupIds?: number[];
};

const getGroupsWithFilters = async (params: ManageGroupsParams) => {
  return (
    await EXPRESS_API.get(
      `/superadmin/landing-page-design-groups/manage-groups`,
      {
        params,
      }
    )
  ).data as IManageGroupsResponse;
};

export const useQueryGetGroupsWithFilters = (params: ManageGroupsParams) => {
  return useQuery(
    landingPageDesignGroupsKeys.list(params),
    () => getGroupsWithFilters(params),
    {
      onError: () => {
        errorToast({
          title: `We're currently experiencing difficulties fetching groups.`,
        });
      },
    }
  );
};
